import { useState, useEffect } from 'react';
import { ReadingsService } from 'src/services/readings/readings.service';
import { subHours } from 'date-fns';
import { LatestReadingsResponse, LatestReadingWithDisplay } from 'src/types/readings/readings';
import { useAuthentication } from 'src/features/authentication/context';

type UseGatewayReadingsArgs = {
  gatewayId?: string;
  tagId?: string;
};

export const useGatewayReadings = ({ gatewayId, tagId }: UseGatewayReadingsArgs) => {
  const {
    customerId: { value: customerId },
  } = useAuthentication();
  const [readings, setReadings] = useState<LatestReadingsResponse>({});
  const [isDataReady, setIsDataReady] = useState<boolean>(false);

  const display = readings && (readings[tagId!] as LatestReadingWithDisplay)?.display;

  useEffect(() => {
    if (!gatewayId || !tagId) return;

    const controller = new AbortController();

    const now = new Date();
    const startDate = subHours(now, 3).toISOString();
    const endDate = now.toISOString();

    ReadingsService.getReadingsNewDataStorage({
      customerId: customerId!,
      gatewayId: gatewayId,
      startDate: startDate,
      endDate: endDate,
      measurements: tagId,
      aggregationType: null,
      includeDisplayConfig: true,
    })
      .then((res) => {
        if (!controller.signal.aborted) {
          setReadings(res.data);
        }
      })
      .catch((error) => {
        if (!controller.signal.aborted) {
          console.error(error);
        }
      })
      .finally(() => {
        if (!controller.signal.aborted) {
          setIsDataReady(true);
        }
      });

    return () => {
      controller.abort();
    };
  }, [tagId, gatewayId, customerId]);

  return { readings, isDataReady, display };
};
